<template>
    <div>
        <el-table
            :data="quote_order_list"
            :default-sort="{prop: '', order: ''}"
            @sort-change="handleTableSort"
			@selection-change="handleSelectionChange"
			empty-text="暫無數據"
			>
			<el-table-column
			    type="selection"
			    width="44"
				>
			</el-table-column>
            <!-- 订单号 -->
            <el-table-column
                :label="$t('message.cqorder.table1')"
                prop="quote_id"
                align="center"
                width="150"
                sortable="custom"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <el-button
                        type="text"
                        @click="getQuoteOrderDetail(row.quote_id)">
                        <span>{{row.quote_sn}}</span>
                    </el-button>
                </template>
            </el-table-column>
            <!-- 日期 -->
            <el-table-column
                :label="$t('message.cqorder.table2')"
                prop="createtime"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <div>{{row.createtime.split(' ')[0]}}</div>
                </template>
            </el-table-column>
            <!-- 操作用户 -->
            <el-table-column
                :label="$t('message.cqorder.table3')"
                prop="username"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 部门 -->
            <el-table-column
                :label="$t('message.cqorder.table4')"
                prop="departmentname"
                align="center"
                sortable="custom"
                show-overflow-tooltip
                v-if="!power.includes(111)">
            </el-table-column>
            <!-- 卖家留言 -->
            <el-table-column
                :label="$t('message.cqorder.table11')"
                prop="to_buyer"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
            </el-table-column>
            <!-- 状态 -->
            <el-table-column
                :label="$t('message.cqorder.table5')"
                prop="quote_status"
                align="center"
                sortable="custom"
                show-overflow-tooltip>
                <template v-slot="{ row }">
                    <!-- 已通过审批 -->
                    <template v-if="row.complete_status==0||row.complete_status==10">
                        <div>{{row.quote_status==0? $t("message.cqorder.status1"): $t("message.cqorder.status2")}}</div>
                    </template>
                    <!-- 未通过 -->
                    <template v-else>
                        <div>
                            {{row.complete_status==5? $t("message.cqorder.status3"): $t("message.cqorder.status4")}}
                        </div>
                    </template>
                </template>
            </el-table-column>
        </el-table>
		<div class="pagination-btn">
		    <el-button 
				@click="handleExport"
		        type="primary">
		        全部導出
		    </el-button>
		</div>
       <table-pagination
            :current-page="currentPage"
            :page-count="pageCount"
            @current-change="handleCurrent">
        </table-pagination>
		<div style="padding: 10px; display: flex;justify-content: flex-end;">
			<el-pagination
			  @current-change="handleCurrent"
			  :current-page.sync="currentPage2"
			  :page-size="page.per_page"
			  layout="prev, pager, next, jumper"
			  :total="page.total"
			  background>
			</el-pagination>
		</div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { tableSortHandle } from "@/utils/publicMethod.js";

export default {
    mixins: [ tableSortHandle ],
    computed: mapState({
        quote_order_list: state => state.order.quote_order_list,
        power: state => state.user.power,
		page: state => state.user.page
    }),
	data() {
		return {
			currentPage2:0,
		}
	},
	watch:{
		currentPage(){
			this.currentPage2 = this.currentPage
		}
	},
    methods: {
        ...mapActions([
            "getQuoteOrderDetail"
        ]),
		handleExport() {
		    this.$emit('handle-export')
		},
		
    },
}
</script>
<style scoped>
.pagination-btn {
    margin: 20px;
}


</style>